import { render, staticRenderFns } from "./AISTable.vue?vue&type=template&id=f87e1aa4&scoped=true&"
import script from "./AISTable.vue?vue&type=script&lang=js&"
export * from "./AISTable.vue?vue&type=script&lang=js&"
import style0 from "./AISTable.vue?vue&type=style&index=0&id=f87e1aa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87e1aa4",
  null
  
)

export default component.exports